import {
  InputGroup
} from "./chunk-6OJINZ37.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/form/textarea/textarea.tsx
import { forwardRef } from "react";
import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { jsx } from "react/jsx-runtime";
var Textarea = forwardRef(function Textarea2(_a, ref) {
  var _b = _a, { className, size, errorMessage, labelProps, label, id, style, disabled, readOnly } = _b, rest = __objRest(_b, ["className", "size", "errorMessage", "labelProps", "label", "id", "style", "disabled", "readOnly"]);
  return /* @__PURE__ */ jsx(
    InputGroup,
    {
      className: clsx("hds-textarea", className),
      disabled,
      errorMessage,
      id,
      label,
      labelProps,
      readOnly,
      style,
      size,
      children: /* @__PURE__ */ jsx("textarea", __spreadProps(__spreadValues({}, rest), { disabled, readOnly, ref }))
    }
  );
});
Textarea.displayName = "Textarea";

export {
  Textarea
};
//# sourceMappingURL=chunk-N4W3OMA2.mjs.map